import React, { useState, useEffect } from "react";

const CustomTimePicker = ({ value, onChange }) => {
  // Convert 24h format ("HH:mm:ss") to 12h format ("hh:mm AM/PM")
  const parseTime = (val) => {
    if (!val) return { hours: "", minutes: "", ampm: "AM" };

    // Handle case where value is already in 12h format
    if (val.includes(" ")) {
      const [time, period] = val.split(" ");
      const [hours, minutes] = time.split(":");
      return {
        hours: hours || "01",
        minutes: minutes || "00",
        ampm: period || "AM",
      };
    }

    // Handle 24h format
    const timePart = val.includes(":") ? val.split(":") : ["00", "00"];
    let hours24 = parseInt(timePart[0], 10) || 0;
    const minutes = timePart[1] ? timePart[1].padStart(2, "0") : "00";

    let hours12 = hours24;
    let ampm = "AM";

    if (hours24 >= 12) {
      ampm = "PM";
      if (hours24 > 12) hours12 = hours24 - 12;
    }
    if (hours24 === 0) hours12 = 12;

    return {
      hours: hours12.toString().padStart(2, "0"),
      minutes,
      ampm,
    };
  };

  const [time, setTime] = useState(parseTime(value));

  useEffect(() => {
    setTime(parseTime(value));
  }, [value]);

  const convertTo24Hour = (hours, minutes, ampm) => {
    if (!hours || !minutes) return "";

    let hh = parseInt(hours, 10);
    let mm = minutes.split(":")[0]; // remove any seconds part if present

    if (ampm === "PM" && hh < 12) hh += 12;
    if (ampm === "AM" && hh === 12) hh = 0;
    return `${hh.toString().padStart(2, "0")}:${minutes}:00`;
  };

  const handleChange = (field, val) => {
    const newTime = { ...time, [field]: val };
    setTime(newTime);

    if (newTime.hours && newTime.minutes) {
      const backendTime = convertTo24Hour(
        newTime.hours,
        newTime.minutes,
        newTime.ampm
      );
      onChange(backendTime);
    }
  };

  const inputStyle = {
    border: "1px solid #c2dfff",
    borderRadius: "3px",
    height: "35px",
    padding: "0 5px",
    width: "100%",
    background: "#fff",
  };

  const selectWrapperStyle = {
    display: "flex",
    gap: "5px",
    alignItems: "center",
    width: "100%",
  };

  const hoursOptions = Array.from({ length: 12 }, (_, i) => {
    const hour = (i + 1).toString().padStart(2, "0");
    return (
      <option key={hour} value={hour}>
        {hour}
      </option>
    );
  });

  const minutesOptions = Array.from({ length: 60 }, (_, i) => {
    const min = i.toString().padStart(2, "0");
    return (
      <option key={min} value={min}>
        {min}
      </option>
    );
  });

  return (
    <div style={selectWrapperStyle}>
      <select
        style={inputStyle}
        value={time.hours}
        onChange={(e) => handleChange("hours", e.target.value)}
      >
        <option disabled value="">
          HH
        </option>
        {hoursOptions}
      </select>

      <span>:</span>

      <select
        style={inputStyle}
        value={time.minutes}
        onChange={(e) => handleChange("minutes", e.target.value)}
      >
        <option disabled value="">
          MM
        </option>
        {minutesOptions}
      </select>

      <select
        style={inputStyle}
        value={time.ampm}
        onChange={(e) => handleChange("ampm", e.target.value)}
      >
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  );
};

export default CustomTimePicker;
